import React, { useState } from "react";
import { toast } from "sonner";
import type {
  EventLogEntry,
  LoadingState,
  StoredSubmission,
} from "@/types/fitconnect";
import { getSubmissionEventLog } from "@/lib/fitconnect";
import { StoredSubmissionSelector } from "@/components/StoredSubmissionSelector.tsx";
import { EventLogList } from "@/components/EventLogList.tsx";
import { useStoredSubmissions } from "@/hooks/useStoredSubmissions.ts";

const EventLog = () => {
  const { listLoadingState, listResponseData } = useStoredSubmissions(false);
  const [detailLoadingState, setDetailLoadingState] =
    useState<LoadingState>("initial");
  const [detailResponseData, setDetailResponseData] = useState<EventLogEntry[]>(
    [],
  );
  const [selectedSubmission, setSelectedSubmission] =
    useState<StoredSubmission | null>(null);

  const loadDetail = async (submissionId: string) => {
    try {
      setDetailLoadingState("pending");

      const response = await getSubmissionEventLog(submissionId);

      setDetailResponseData(response.eventLogEntries);
      setDetailLoadingState(response.error ? "error" : "success");

      if (response.error) {
        toast.error("Event-Log abfragen fehlgeschlagen", {
          description: response.error,
        });
      }
    } catch (error) {
      const msg = error instanceof Error ? error.message : "unbekannter Fehler";
      setDetailLoadingState("error");
      setDetailResponseData([]);
      toast.error("Event-Log abfragen fehlgeschlagen", {
        description: msg,
      });
    }
  };

  return (
    <main className="container">
      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-1">Event Log</h1>
        <p className="text-base-content/70">
          Auflisten aller Security Event Tokens des Event-Logs. Wählen Sie dazu
          eine Submission aus der Liste aus.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <StoredSubmissionSelector
          submissions={listResponseData}
          onSelect={(s) => {
            setSelectedSubmission(s);
            loadDetail(s.submissionId);
          }}
          selectedId={
            selectedSubmission ? selectedSubmission.submissionId : null
          }
          isLoading={listLoadingState === "pending"}
        />
        <EventLogList
          eventLogEntries={detailResponseData}
          isLoading={detailLoadingState === "pending"}
        />
      </div>
    </main>
  );
};

export default EventLog;
